import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const MailIcon: React.FC<SvgProps> = ({ color, ...props }) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g id="mail">
        <path
          id="Vector"
          d="M1 3H23V21H1V3ZM3 5V6.82947L12 11.3795L21 6.82947V5H3ZM21 9.07053L12 13.6205L3 9.07053V19H21V9.07053Z"
          fill={color || '#999999'}
        />
      </g>
    </Svg>
  )
}

export default MailIcon
